module.exports = __webpack_public_path__ + "img/milkpot.8b47e926.png";